import * as React from "react";
import {
  Fade,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import moment from "moment";
import BatchProcessingModal from "../../components/BatchProcessingModal";
import { Icon } from "@iconify/react";
import ConfirmationModal from "../../../../../../components/ConfirmationModal";
import { useDispatch } from "react-redux";
import { retryBatchProcess } from "../../../../../../api/order";

function Row(props) {
  const { row } = props;
  const shouldBold = { fontWeight: "bold" };
  const dispatch = useDispatch();

  return (
    <React.Fragment>
      <TableRow
        sx={{
          "& > *": { borderBottom: "unset" },
          borderBottom: "1px solid #ebebeb",
          width: "100%",
          "&:hover": {
            backgroundColor: "rgba(244,244,244,.5)",
          },
        }}
      >
        <TableCell sx={shouldBold}>{row?.batch_process_id}</TableCell>
        <TableCell sx={shouldBold} align="center">
          {
            row?.orders?.filter(
              (order) =>
                order?.status === "processing"
            ).length
          }
        </TableCell>
        <TableCell sx={shouldBold} align="center">
          {row?.orders?.filter((order) => order?.status === "Shipped").length}
        </TableCell>
        <TableCell sx={shouldBold} align="center">
          {
            row?.orders?.filter((order) => order?.status === "Processing" || order?.status === "rejected")
              .length
          }
        </TableCell>
        <TableCell sx={shouldBold} align="center">
          {moment(row?.createdAt).format("YYYY-MM-DD")}
        </TableCell>
        <TableCell sx={shouldBold}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            {row?.status === "pending" ? (
              <div
                style={{
                  background: "rgb(255, 207, 207)",
                  maxWidth: "100px",
                  textAlign: "center",
                  borderRadius: "25px",
                  padding: "10px 20px",
                }}
              >
                <strong>Pending</strong>
              </div>
            ) : (
              <div
                style={{
                  background: "#D4FFD3",
                  maxWidth: "100px",
                  textAlign: "center",
                  borderRadius: "25px",
                  padding: "10px 20px",
                }}
              >
                <strong>Fulfilled</strong>
              </div>
            )}
          </div>
        </TableCell>

        <TableCell>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <BatchProcessingModal title="view" processId={row?._id} />
            <Tooltip
              title="Retry Batch Process"
              placement="top-end"
              TransitionComponent={Fade}
            >
              <Icon
                icon="ion:reload"
                width="20"
                height="20"
                style={{
                  cursor: "pointer",
                  //   marginTop: "6px",
                  margin: "6px 10px 0px 10px",
                }}
                onClick={() =>
                  dispatch(
                    retryBatchProcess({
                      processId: row?._id,
                      updateDetails: row?.orders,
                    })
                  )
                }
              />
            </Tooltip>
            <div style={{ marginTop: "8px" }}>
              <ConfirmationModal
                icon="delete"
                title="Are you sure you want to delete this batch process from the list?"
                confirm="Delete"
                elementId={row?._id}
              />
            </div>
          </div>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}
export default function BatchProcessDataTable({ orders }) {
  const tableHeadStyles = {
    color: "#707070",
    fontWeight: 500,
  };

  return (
    <TableContainer
      component={Paper}
      sx={{
        marginTop: "20px",
        // padding: "1% ",
        width: "100%",
        boxShadow: "none",
      }}
    >
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow
            sx={{
              background: "#eeeeee",
            }}
          >
            <TableCell
              sx={{ color: "#707070", fontWeight: 500, paddingLeft: "16px" }}
            >
              Batch Process ID
            </TableCell>
            <TableCell
              align="center"
              sx={{ color: "#707070", fontWeight: 500, paddingLeft: "16px" }}
            >
              Active Orders
            </TableCell>
            <TableCell
              align="center"
              sx={{ color: "#707070", fontWeight: 500, paddingLeft: "16px" }}
            >
              Fulfilled Orders
            </TableCell>
            <TableCell
              align="center"
              sx={{ color: "#707070", fontWeight: 500, paddingLeft: "16px" }}
            >
              Rejected Orders
            </TableCell>
            <TableCell
              align="center"
              sx={{ color: "#707070", fontWeight: 500, paddingLeft: "16px" }}
            >
              Batch Processing Date
            </TableCell>
            <TableCell
              align="center"
              sx={{ color: "#707070", fontWeight: 500, paddingLeft: "16px" }}
            >
              Status
            </TableCell>

            <TableCell align="right" sx={tableHeadStyles}>
              Action
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {orders?.map((row) => (
            <Row key={row._id} row={row} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
